import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserContext } from '@/features/common/contexts/user.context';
import { beContacted } from '@/services/job';

export type UseBeContactedReturn = {
  loading: boolean;
  error: string | null;
  request: () => Promise<boolean>;
};

export function useBeContacted(): UseBeContactedReturn {
  const { user } = useUserContext();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const request = useCallback(async () => {
    if (!user?.id) {
      setError('User not found');
      return false;
    }

    setLoading(true);
    setError(null);
    try {
      await beContacted();
      return true;
    } catch (err) {
      console.error('beContacted request failed', err);
      setError(
        t('errors.be_contacted_failed', {
          defaultValue:
            "Votre demande n'a pas été envoyée. Vérifiez votre connexion puis réessayez.",
        }),
      );
      return false;
    } finally {
      setLoading(false);
    }
  }, [user?.id, t]);

  return { loading, error, request };
}
